// Dependency-free deep equality. Replaces the former json-stable-stringify approach, which dragged
// json-stable-stringify + get-intrinsic + jsonify + object-keys into the eager first-paint chunk
// (this module is reached via the chats/channels slices → store → src/index.js). The only callers
// compare plain server-JSON objects (membership), where structural equality is exactly equivalent
// to stable-stringify equality — and faster, since it short-circuits on the first difference.
export const isSameObject = (a, b) => {
  if (a === b) return true; // primitives, same reference, null===null, undefined===undefined
  if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') return false;

  const aIsArray = Array.isArray(a);
  if (aIsArray !== Array.isArray(b)) return false;

  if (aIsArray) {
    if (a.length !== b.length) return false;
    return a.every((item, i) => isSameObject(item, b[i]));
  }

  const aKeys = Object.keys(a);
  if (aKeys.length !== Object.keys(b).length) return false;
  return aKeys.every((key) => Object.hasOwn(b, key) && isSameObject(a[key], b[key]));
};
